// extracted by mini-css-extract-plugin
export default {"root":"style_root__MP7jp","row":"style_row__GE9r-"};